import { render, staticRenderFns } from "./detail-text-row.vue?vue&type=template&id=471b32fd&"
import script from "./detail-text-row.vue?vue&type=script&lang=js&"
export * from "./detail-text-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('471b32fd')) {
      api.createRecord('471b32fd', component.options)
    } else {
      api.reload('471b32fd', component.options)
    }
    module.hot.accept("./detail-text-row.vue?vue&type=template&id=471b32fd&", function () {
      api.rerender('471b32fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/detail-text-row.vue"
export default component.exports